import { useEffect, useContext } from "react";
import Header from "./Header";
import useState from "react-usestateref";
import authservices from "../services/authservices";
import { Link } from "react-router-dom";
import SubFooter from "./SubFooter";
import { useTranslation } from "react-i18next";
import { UserContext } from "../contexts/UserContext";
import i18n from "../translate/i18n";

const Guides = () => {
  const [userAuth, setAuth, userAuthref] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    getSitedata();
  }, []);
  const [siteDatacomes, setSiteData] = useState("");

  const getSitedata = async () => {
    try {
      const data = await authservices.getsitedata();
      if (data.status == true) {
        setSiteData(data.data);
        // console.log(data, "=-=-=get site datas =-=-", data.data);
      }
    } catch (error) {}
  };

  const [i18nextLngs, seti18nextLngs] = useState(
    localStorage.getItem("i18nextLng") || "en" || "et" || "fi"
  );
  const { i18nextLng } = useContext(UserContext);
  useEffect(() => {
    if (i18nextLng === "en") {
      i18n.changeLanguage(i18nextLngs);
      document.documentElement.lang = i18nextLngs;
      localStorage.setItem("i18nextLng", i18nextLngs);
    }
  }, [i18nextLng]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <>
      {" "}
      <main className="wyscale_landing_main">
        <Header />
      </main>
      <section className="dashboard_content_section">
        <div className="container">
          <div className="smart_dashboard_content" id="terms-condition">
            <h2>{t("Guides&Tutorials")}</h2>
            <div className="row">
              <div className="col-lg-12">
                <div className="dash_board_profile_content">
                  <div className="contentpage">
                    <h3>{t("EducationalResourceSection")}</h3>
                    <hr
                      style={{
                        borderBottom: "1px solid white",
                        margin: "10px 0",
                      }}
                    />

                    <p>{t("BinargeAcademyIs")}</p>

                    <h3>1. {t("BeginnerBasics")}</h3>
                    <h3>{t("WhatIsCrypto")}</h3>

                    <p>{t("TradingBot")}</p>

                    <h3>{t("WhatAPIKey?")}</h3>
                    <p>{t("SecureDigital")}</p>

                    <h3>{t("ArbitrageTrading")}</h3>
                    <p>{t("ArbitrageMeansBuying")}</p>
                    <hr
                      style={{
                        borderBottom: "1px solid white",
                        margin: "10px 0",
                      }}
                    />
                    <h3>2. {t("StrategyDeepDives")}</h3>

                    <h3>{t("DCA")}</h3>

                    <p>{t("DCAStrategy")}</p>

                    <h3>{t("IntradayStrategy")}</h3>
                    <p>{t("IntradayTrades")}</p>

                    <h3>{t("TriangularArbitrage")}</h3>
                    <p>{t("ThisStrategyUsesThreePairs")}</p>

                    <h3> {t("MultiExchangeArbitrage")}</h3>
                    <p>{t("BuyOnExchange")}</p>

                    <h3> {t("MomentumStrategy")}</h3>
                    <p>{t("MomentumStrategyIs")}</p>
                    <ul className="num_lists_guide">
                      <li>{t("BotConstantly")}</li>
                      <li>{t("Cryptocurrencies")}</li>
                      <li>{t("RisingFast")}</li>
                      <li>{t("BotAutomatically")}</li>
                      <li>{t("SmallProfit")}:</li>
                      {/* <li>{t("ItSellsTheCoin")}</li>
                      <li>{t("StartsLooking")}</li> */}
                      <li>{t("ProcessRuns")}</li>
                    </ul>
                    <hr
                      style={{
                        borderBottom: "1px solid white",
                        margin: "10px 0",
                      }}
                    />

                    <h3>3. {t("Risk&Security")}</h3>
                    <h3>{t("WhoControlsTheFunds")}</h3>
                    <p>{t("YouDo")}</p>
                    <h3>{t("HowIsRiskManaged")}</h3>
                    <p>{t("BinargeUsesAdvancedSafeguards")}</p>
                    <ul>
                      <li>{t("Max2%Capital")}</li>
                      <li>{t("OnlyHighliquidityPairs")}</li>
                      <li>{t("NoGuessing")}</li>
                      <li>{t("NoWithdrawal")}</li>
                    </ul>
                    <h3>{t("WhatIsTheFuelWallet")}</h3>
                    <p>{t("FuelWalletIsUsedToCover")}</p>
                    <hr
                      style={{
                        borderBottom: "1px solid white",
                        margin: "10px 0",
                      }}
                    />

                    <h3>4. {t("GettingStarted")}</h3>
                    <h3>{t("HowToRegisterAndConnectYourExchange")}</h3>
                    <p>{t("GoToBinarge")}</p>
                    <h3>{t("HowToFundTheFuelWallet")}</h3>
                    <p>{t("Depositusdt")}</p>
                    <h3>{t("HowToTrackPerformance")}</h3>
                    <p>{t("YouCanMonitorTrades")}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <SubFooter />
    </>
  );
};

export default Guides;
